import { observer } from "mobx-react-lite";

import { IconArrowDown, IconList } from "@synthesis/shared-icons";
import { Button, type DropdownScheme, type StateProps, Tooltip } from "@synthesis/shared-ui";
import { Dropdown } from "@synthesis/shared-ui";

import { ExplorerView, useStores } from "../../store";

type ViewChangeKey = typeof ExplorerView.Grid | typeof ExplorerView.Table;

const scheme: DropdownScheme = [
  {
    type: "ITEMS",
    elements: [
      {
        id: "Grid",
        label: "Сетка",
        value: "Grid",
      },
      {
        id: "Table",
        label: "Таблица",
        value: "Table",
      },
    ],
  },
];

const viewLabels: Record<ViewChangeKey, string> = {
  [ExplorerView.Grid]: "Сетка",
  [ExplorerView.Table]: "Таблица",
};

const isViewChangeKey = (view: (typeof ExplorerView)[keyof typeof ExplorerView]): view is ViewChangeKey =>
  view === ExplorerView.Grid || view === ExplorerView.Table;

const ViewChangeDropdown = observer(() => {
  const { generalStore } = useStores();
  const state: StateProps = {
    Table: () => generalStore.setView(ExplorerView.Table),
    Grid: () => generalStore.setView(ExplorerView.Grid),
  };
  const activeViewLabel = isViewChangeKey(generalStore.view) ? viewLabels[generalStore.view] : viewLabels[ExplorerView.Grid];

  return (
    <Dropdown
      scheme={scheme}
      state={state}
      activeItem={activeViewLabel}
      trigger={
        <Tooltip arrowSide="bottom" description="Вид">
          <Button
            data-cy="viewChangeDropdown-button"
            theme="text"
            size="sm"
            leftIcon={<IconList className="size-5" />}
            rightIcon={<IconArrowDown className="size-5" />}
          />
        </Tooltip>
      }
    />
  );
});

export default ViewChangeDropdown;
